import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { btnCva } from "../../../ui/button"
import JobCard from "./job-card"
import cn from "../../../utils/classname"

const data = {
  title: "Recommended jobs for developers",
  subTitle: "Browse thousands of jobs in Software Development",
  url: process.env.JOBS_URL || "https://jobs.sitepoint.com",
}

const Jobs = () => {
  const { jobs } = useStaticQuery(graphql`
    {
      jobs: allSpJobs(limit: 6) {
        nodes {
          id
          title
          slug
          company_slug
          company_name
          job_type
          publication_date
          location
          description
        }
      }
    }
  `)
  return (
    <div className="mt-[100px] sm:mt-[120px] container-lg flex flex-col gap-8 sm:gap-16">
      <div className="flex flex-col gap-8 items-center">
        <div className="flex flex-col sm:items-center">
          <div className="text-jar-3 text-neutral-11 italic text-left sm:text-center">
            {data.title}
          </div>
          <p className="md:max-w-[496px] text-jar-8 text-neutral-12 font-semibold sm:text-center tracking-tight">
            {data.subTitle}
          </p>
        </div>
        <a
          href={data.url}
          className={cn(
            btnCva({ size: 3, theme: "neutral", variant: "soft" }),
            "w-full sm:w-fit"
          )}
        >
          Browse all jobs
        </a>
      </div>
      <div className="w-[calc(100%+32px)] -mx-4 md:mx-0 md:w-full overflow-hidden">
        <div
          className={cn(
            "flex md:grid md:grid-cols-2 gap-6 overflow-x-auto px-4 md:px-0 snap-x snap-mandatory",
            "pb-5 md:pb-0"
          )}
        >
          {jobs.nodes.map(
            ({
              id,
              title,
              slug,
              company_slug,
              company_name,
              job_type,
              publication_date,
              location,
              description,
            }) => (
              <JobCard
                key={id}
                title={title}
                company_slug={company_slug}
                slug={slug}
                company_name={company_name}
                job_type={job_type}
                publication_date={publication_date}
                location={location}
                description={description}
              />
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default Jobs
